
import { Component, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ContentBaseComponent } from 'projects/shared/lib/components/shared/content/content/content-base.component';
import { WidgetProductCardComponent } from '../widget/productcard/widget-product-card.component';

@Component({
    selector: 'app-content',
    imports: [
    FormsModule,
    forwardRef(() => ContentBaseComponent),
    WidgetProductCardComponent
],
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss']
})
export class ContentComponent extends ContentBaseComponent {

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @angular-eslint/use-lifecycle-interface
  public ngOnInit(): void {
    // disable ngOnInit here since the base is embedded again in the html and only the inputs / utility stuff is reused here and then passed on;
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @angular-eslint/use-lifecycle-interface
  public async ngOnChanges(): Promise<void> {
    // disable ngOnInit here since the base is embedded again in the html and only the inputs / utility stuff is reused here and then passed on;
  }

}
